<template>
  <div class="identity" id="identity">
    <v-card flat="flat" class="nuclear">
      <v-card-title class="nuclear-title">
        Identity & Access Management
      </v-card-title>
      <v-card-text class="nuclear-content" id="team">
        <v-card flat="flat" class="card">
          <v-card-title>
            My Teams
            <div class="dropicon">
              <font-awesome-icon />
            </div>
          </v-card-title>
          <v-card-text>
            <v-row class="myteam">
              <v-col cols="12" sm="5" md="3" lg="3" class="mobile">
                <p class="bold">TEAM</p>
                <v-autocomplete
                  v-model="teamManager"
                  label="Team Name"
                  :rules="fieldRules"
                  item-text="name"
                  return-object
                  required
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="4" md="3" lg="3" class="mobile">
                <p class="bold">GROUP</p>
                <v-autocomplete
                  v-model="teamManager"
                  label="Team Name"
                  :rules="fieldRules"
                  item-text="name"
                  return-object
                  required
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="9" md="6" lg="6" class="tablet_desktop">
                <v-row class="non_border">
                  <v-col cols="12" sm="6" md="6" lg="6" class="team">
                    <p class="bold">TEAM</p>
                  </v-col>
                  <v-col cols="12" sm="6" md="6" lg="6" class="team">
                    <p class="bold">GROUP</p>
                  </v-col>
                </v-row>
                <v-row class="border">
                  <v-col cols="12" sm="6" md="6" lg="6" class="team">
                    <v-autocomplete
                      v-model="teamManager"
                      label="Team Name"
                      :rules="fieldRules"
                      item-text="name"
                      return-object
                      required
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="6" md="6" lg="6" class="team">
                    <v-autocomplete
                      v-model="teamManager"
                      label="Group Name"
                      :rules="fieldRules"
                      item-text="name"
                      return-object
                      required
                    ></v-autocomplete>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" sm="3" md="2" lg="2" class="team_action">
                <v-dialog v-model="deletedialog" persistent max-width="320">
                  <template v-slot:activator="{ on }">
                    <div class="action" v-on="on">
                      <font-awesome-icon class="delete" icon="trash-alt" />
                      <p>Delete Group</p>
                    </div>
                  </template>
                  <v-card class="modal">
                    <v-card-title>
                      <font-awesome-icon
                        class="delete_header"
                        icon="info-circle"
                      />
                      <p>Group Delete Confirmation</p>
                    </v-card-title>
                    <v-card-text
                      >Are you sure you want to
                      <span class="bold">delete</span> this group
                      <span class="bold">forever</span>?</v-card-text
                    >
                    <v-card-actions>
                      <v-btn small class="delete" @click="deleteTeam(item)"
                        >Yes</v-btn
                      >
                      <v-btn small class="cancel" @click="deletedialog = false"
                        >No</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-col>
              <v-col cols="12" sm="5" md="2" lg="2" class="teamname">
                <v-text-field
                  v-model="groupname"
                  label="Group Name"
                  :rules="fieldRules"
                  type="text"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" md="2" lg="2" class="createteam">
                <div class="create">
                  <v-btn color="white" @click="createTeam"
                    >CREATE A NEW GROUP</v-btn
                  >
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-card-text class="useraccount">
        <div>
          <div class="button_group">
            <div class="alluser_btn">
              <v-btn
                :class="this.showallusers ? 'active_btn' : 'default_btn'"
                @click="ShowAllUsers"
                >All Users</v-btn
              >
            </div>
            <div class="activeteam_btn">
              <v-btn
                :class="this.showactiveteam ? 'active_btn' : 'default_btn'"
                @click="ShowActiveTeam"
                >Active Team</v-btn
              >
            </div>
          </div>
          <v-card>
            <v-card-title>
              <v-row>
                <v-col cols="12" sm="5" md="5" lg="5" class="account"
                  >Users in this Group</v-col
                >
                <v-col cols="12" sm="4" md="4" lg="4" class="managers"></v-col>
                <v-col cols="12" sm="3" md="3" lg="3" class="controls">
                  <div class="search_control">
                    <font-awesome-icon class="search_icon" icon="search" />
                    <input
                      type="text"
                      placeholder="Search User"
                      v-model="search"
                    />
                  </div>
                  <div class="dropicon">
                    <font-awesome-icon
                      class="down-arrow"
                      icon="chevron-down"
                      @click="ShowTableControl"
                    />
                  </div>
                </v-col>
              </v-row>
            </v-card-title>
            <v-card-text>
              <v-row class="table_control">
                <v-col cols="12" sm="3" md="3" lg="3">
                  <v-autocomplete
                    v-model="bulkaction"
                    label="Bulk actions"
                    :rules="fieldRules"
                    :items="bulkactions"
                    required
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="2" md="1" lg="1" class="control_button">
                  <v-btn color="white">COMMIT</v-btn>
                </v-col>
                <v-col cols="12" sm="2" md="3" lg="3">
                  <v-autocomplete
                    v-model="sortBy"
                    label="Sort by"
                    :rules="fieldRules"
                    :items="sortbyOptions"
                    required
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-data-table
                v-model="selected"
                :single-select="singleSelect"
                :headers="headers"
                :items="allusers"
                :hide-default-header="true"
                :hide-default-footer="true"
                :single-expand="singleExpand"
                :search="search"
                :expanded.sync="expanded"
                :disable-pagination="true"
                :sort-by="sortBy"
                item-key="id"
                show-expand
                show-select
              >
                <template v-slot:expanded-item="{ headers, item }">
                  <td :colspan="headers.length - 1">
                    <v-row>
                      <v-col cols="12" sm="3" md="2" lg="2">
                        <v-row>
                          <v-col cols="12" sm="12" md="12" lg="12">
                            <div class="expanded_item">
                              <span class="bold">Company</span
                              ><span>{{ item.company }}</span>
                            </div>
                          </v-col>
                          <v-col cols="12" sm="12" md="12" lg="12">
                            <div class="expanded_item">
                              <span class="bold">Title</span
                              ><span>{{ item.title }}</span>
                            </div>
                          </v-col>
                          <v-col cols="12" sm="18" md="8" lg="8">
                            <div class="expanded_item regular">
                              <v-autocomplete
                                v-model="regular_user"
                                label="regular user"
                                :rules="fieldRules"
                                :items="users"
                                required
                              ></v-autocomplete>
                            </div>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" sm="9" md="6" lg="6">
                        <v-row>
                          <v-col cols="12" sm="12" md="12" lg="12">
                            <div class="expanded_item">
                              <span class="bold address">Address</span
                              ><span>{{ item.address }}</span>
                            </div>
                          </v-col>
                          <v-col cols="12" sm="4" md="4" lg="4">
                            <div class="expanded_item">
                              <span class="bold">Language</span
                              ><span class="language">{{ item.language }}</span>
                            </div>
                          </v-col>
                          <v-col cols="12" sm="4" md="4" lg="4">
                            <div class="expanded_item">
                              <span class="bold">Timezone</span
                              ><span>{{ item.timezone }}</span>
                            </div>
                          </v-col>
                          <v-col cols="12" sm="4" md="12" lg="12">
                            <div class="expanded_item">
                              <span class="bold">Gender</span
                              ><span>{{ item.gender }}</span>
                            </div>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" sm="12" md="4" lg="4">
                        <v-row>
                          <v-col cols="12" sm="3" md="6" lg="6" class="change">
                            <div class="action_item">
                              <font-awesome-icon
                                class="action-icon"
                                icon="hashtag"
                              /><span class="action">change password</span>
                            </div>
                          </v-col>
                          <v-col cols="12" sm="3" md="6" lg="6">
                            <div class="action_item">
                              <font-awesome-icon
                                class="action-icon"
                                icon="pause"
                              /><span class="action">pause account</span>
                            </div>
                          </v-col>
                          <v-col cols="12" sm="3" md="6" lg="6" class="remove">
                            <div class="action_item">
                              <font-awesome-icon
                                class="action-icon"
                                icon="share"
                              /><span class="action">remove admin</span>
                            </div>
                          </v-col>
                          <v-col cols="12" sm="3" md="6" lg="6">
                            <div class="action_item">
                              <font-awesome-icon
                                class="action-icon"
                                icon="eye"
                              /><span class="action">add to team</span>
                            </div>
                          </v-col>
                          <v-col cols="12" sm="3" md="6" lg="6">
                            <div class="action_item">
                              <font-awesome-icon
                                class="action-icon"
                                icon="pencil-alt"
                              /><span class="action" @click="EditAccount(item)"
                                >edit account</span
                              >
                            </div>
                            <v-dialog v-model="accountdialog" max-width="500px">
                              <v-card>
                                <v-card-title>
                                  <span class="headline">Edit Account</span>
                                </v-card-title>

                                <v-card-text>
                                  <v-container>
                                    <v-row>
                                      <v-col cols="12" sm="6" md="6">
                                        <v-text-field
                                          v-model="editedItem.fullname"
                                          label="Full Name"
                                          :rules="fieldRules"
                                          required
                                        ></v-text-field>
                                      </v-col>
                                      <v-col cols="12" sm="6" md="6">
                                        <v-autocomplete
                                          v-model="editedItem.team"
                                          label="Team"
                                          :rules="fieldRules"
                                          :items="teams"
                                          required
                                        ></v-autocomplete>
                                      </v-col>
                                      <v-col cols="12" sm="6" md="6">
                                        <v-text-field
                                          v-model="editedItem.email"
                                          label="Email"
                                          :rules="fieldRules"
                                          type="email"
                                          required
                                        ></v-text-field>
                                      </v-col>
                                      <v-col cols="12" sm="6" md="6">
                                        <v-text-field
                                          v-model="editedItem.phone"
                                          label="Phone"
                                          type="text"
                                          v-mask="'(###) ###-####'"
                                          required
                                        ></v-text-field>
                                      </v-col>
                                      <v-col cols="12" sm="12" md="12">
                                        <v-text-field
                                          v-model="editedItem.address"
                                          label="Address"
                                          :rules="fieldRules"
                                          required
                                        ></v-text-field>
                                      </v-col>
                                      <v-col cols="12" sm="6" md="6">
                                        <v-text-field
                                          v-model="editedItem.company"
                                          label="Company"
                                          :rules="fieldRules"
                                          required
                                        ></v-text-field>
                                      </v-col>
                                      <v-col cols="12" sm="6" md="6">
                                        <v-text-field
                                          v-model="editedItem.title"
                                          label="Title"
                                          :rules="fieldRules"
                                          required
                                        ></v-text-field>
                                      </v-col>
                                      <v-col cols="12" sm="6" md="6">
                                        <v-autocomplete
                                          v-model="editedItem.language"
                                          label="Language"
                                          :rules="fieldRules"
                                          :items="languageOptions"
                                          required
                                        ></v-autocomplete>
                                      </v-col>
                                      <v-col cols="12" sm="6" md="6">
                                        <v-autocomplete
                                          v-model="editedItem.timezone"
                                          label="Timezone"
                                          :rules="fieldRules"
                                          :items="timezoneOptions"
                                          required
                                        ></v-autocomplete>
                                      </v-col>
                                      <v-col cols="12" sm="12" md="12">
                                        <v-radio-group
                                          v-model="editedItem.gender"
                                          row
                                          label="Gender"
                                          class="d-flex justify-content-sm-between"
                                          :rules="fieldRules"
                                          required
                                        >
                                          <v-radio
                                            label="Male"
                                            value="male"
                                            color="#5f6f85"
                                          ></v-radio>
                                          <v-radio
                                            label="Female"
                                            value="female"
                                            color="#5f6f85"
                                          ></v-radio>
                                          <v-radio
                                            label="Unspecified"
                                            value="unspecified"
                                            color="#5f6f85"
                                          ></v-radio>
                                        </v-radio-group>
                                      </v-col>
                                    </v-row>
                                  </v-container>
                                </v-card-text>
                                <v-card-actions>
                                  <div class="flex-grow-1"></div>
                                  <v-btn class="cancel" text @click="close"
                                    >Cancel</v-btn
                                  >
                                  <v-btn class="save" text @click="save"
                                    >Save</v-btn
                                  >
                                </v-card-actions>
                              </v-card>
                            </v-dialog>
                          </v-col>
                          <v-col cols="12" sm="3" md="6" lg="6">
                            <div class="action_item">
                              <font-awesome-icon
                                class="action-icon"
                                icon="trash-alt"
                              /><span class="delete">delete account</span>
                            </div>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </td>
                </template>
                <template v-slot:item.image>
                  <img
                    src="/assets/images/myprofile.png"
                    alt=""
                    width="49px"
                    height="49px"
                    class="image"
                  />
                </template>
                <template v-slot:item.fullname="{ item }">
                  <div class="original">
                    <div class="fullname">
                      <span class="bold">Full name</span
                      ><span>{{ item.fullname }}</span>
                    </div>
                    <div class="fullname">
                      <span class="bold">Team</span><span>{{ item.team }}</span>
                    </div>
                  </div>
                  <div class="additional">
                    <div class="fullname">
                      <span class="bold">Last login</span
                      ><span>{{ item.lastlogin }}</span>
                    </div>
                    <div class="fullname">
                      <span class="bold"># of uploaded config files</span
                      ><span>{{ item.configfiles }}</span>
                    </div>
                  </div>
                </template>
                <template v-slot:item.emailphone="{ item }">
                  <div class="original">
                    <div class="fullname">
                      <span class="bold">Email</span
                      ><span>{{ item.email }}</span>
                    </div>
                    <div class="fullname">
                      <span class="bold">Phone</span
                      ><span>{{ item.phone }}</span>
                    </div>
                  </div>
                  <div class="additional">
                    <div class="fullname">
                      <span class="bold"># of vulnerabilities hunted</span
                      ><span>{{ item.hunted }}</span>
                    </div>
                    <div class="fullname">
                      <span class="bold"
                        ># of critical vulnerabilities hunted</span
                      ><span>{{ item.critical_hunted }}</span>
                    </div>
                  </div>
                  <div class="collapse_icon">
                    <font-awesome-icon
                      class="report"
                      icon="ellipsis-h"
                      @click="expandOnMobile"
                    />
                  </div>
                </template>
                <template v-slot:item.loginconfig="{ item }">
                  <div class="fullname">
                    <span class="bold">Last login</span
                    ><span>{{ item.lastlogin }}</span>
                  </div>
                  <div class="fullname">
                    <span class="bold"># of uploaded config files</span
                    ><span>{{ item.configfiles }}</span>
                  </div>
                </template>
                <template v-slot:item.hunted="{ item }">
                  <div class="fullname">
                    <span class="bold"># of vulnerabilities hunted</span
                    ><span>{{ item.hunted }}</span>
                  </div>
                  <div class="fullname">
                    <span class="bold"
                      ># of critical vulnerabilities hunted</span
                    ><span>{{ item.critical_hunted }}</span>
                  </div>
                </template>
                <template v-slot:item.report="{ item }">
                  <font-awesome-icon
                    class="report"
                    icon="ellipsis-h"
                    @click="expandOnDesktop"
                  />
                </template>
              </v-data-table>
            </v-card-text>
            <v-card-text v-if="this.showactiveteam == true">
              <v-row class="table_control" v-if="this.showtablecontrol == true">
                <v-col cols="12" sm="3" md="3" lg="3">
                  <v-autocomplete
                    v-model="bulkaction"
                    label="Bulk actions"
                    :rules="fieldRules"
                    :items="bulkactions"
                    required
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="2" md="1" lg="1" class="control_button">
                  <v-btn color="white">COMMIT</v-btn>
                </v-col>
                <v-col cols="12" sm="2" md="3" lg="3">
                  <v-autocomplete
                    v-model="sortBy"
                    label="Sort by"
                    :rules="fieldRules"
                    :items="sortbyOptions"
                    required
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-data-table
                v-model="selected"
                :single-select="singleSelect"
                :headers="headers"
                :items="activeteams"
                :hide-default-header="true"
                :hide-default-footer="true"
                :single-expand="singleExpand"
                :expanded.sync="expanded"
                item-key="id"
                show-expand
                show-select
              >
                <template v-slot:expanded-item="{ headers, item }">
                  <td :colspan="headers.length">
                    <v-row>
                      <v-col cols="12" sm="3" md="2" lg="2">
                        <v-row>
                          <v-col cols="12" sm="12" md="12" lg="12">
                            <div class="expanded_item">
                              <span class="bold">Company</span
                              ><span>{{ item.company }}</span>
                            </div>
                          </v-col>
                          <v-col cols="12" sm="12" md="12" lg="12">
                            <div class="expanded_item">
                              <span class="bold">Title</span
                              ><span>{{ item.title }}</span>
                            </div>
                          </v-col>
                          <v-col cols="12" sm="12" md="12" lg="12">
                            <div class="expanded_item">
                              <v-autocomplete
                                v-model="regular_user"
                                label="regular user"
                                :rules="fieldRules"
                                :items="users"
                                required
                              ></v-autocomplete>
                            </div>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" sm="9" md="6" lg="6">
                        <v-row>
                          <v-col cols="12" sm="12" md="12" lg="12">
                            <div class="expanded_item">
                              <span class="bold address">Address</span
                              ><span>{{ item.address }}</span>
                            </div>
                          </v-col>
                          <v-col cols="12" sm="4" md="4" lg="4">
                            <div class="expanded_item">
                              <span class="bold">Language</span
                              ><span class="language">{{ item.language }}</span>
                            </div>
                          </v-col>
                          <v-col cols="12" sm="4" md="8" lg="8">
                            <div class="expanded_item">
                              <span class="bold">Timezone</span
                              ><span>{{ item.timezone }}</span>
                            </div>
                          </v-col>
                          <v-col cols="12" sm="4" md="12" lg="12">
                            <div class="expanded_item">
                              <span class="bold">Gender</span
                              ><span>{{ item.gender }}</span>
                            </div>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" sm="12" md="4" lg="4">
                        <v-row>
                          <v-col cols="12" sm="3" md="6" lg="6" class="change">
                            <div class="action_item">
                              <font-awesome-icon
                                class="action-icon"
                                icon="hashtag"
                              /><span class="action">change password</span>
                            </div>
                          </v-col>
                          <v-col cols="12" sm="3" md="6" lg="6">
                            <div class="action_item">
                              <font-awesome-icon
                                class="action-icon"
                                icon="pause"
                              /><span class="action">pause account</span>
                            </div>
                          </v-col>
                          <v-col cols="12" sm="3" md="6" lg="6" class="remove">
                            <div class="action_item">
                              <font-awesome-icon
                                class="action-icon"
                                icon="share"
                              /><span class="action">remove admin</span>
                            </div>
                          </v-col>
                          <v-col cols="12" sm="3" md="6" lg="6">
                            <div class="action_item">
                              <font-awesome-icon
                                class="action-icon"
                                icon="eye"
                              /><span class="action">add to team</span>
                            </div>
                          </v-col>
                          <v-col cols="12" sm="3" md="6" lg="6">
                            <div class="action_item">
                              <font-awesome-icon
                                class="action-icon"
                                icon="pencil-alt"
                              /><span class="action" @click="EditAccount(item)"
                                >edit account</span
                              >
                            </div>
                            <v-dialog v-model="dialog" max-width="500px">
                              <v-card>
                                <v-card-title>
                                  <span class="headline">Edit Team</span>
                                </v-card-title>

                                <v-card-text>
                                  <v-container>
                                    <v-row>
                                      <v-col cols="12" sm="6" md="6">
                                        <v-text-field
                                          v-model="editedItem.fullname"
                                          label="Full Name"
                                          :rules="fieldRules"
                                          required
                                        ></v-text-field>
                                      </v-col>
                                      <v-col cols="12" sm="6" md="6">
                                        <v-text-field
                                          v-model="editedItem.email"
                                          label="Email"
                                          :rules="fieldRules"
                                          type="email"
                                          required
                                        ></v-text-field>
                                      </v-col>
                                      <v-col cols="12" sm="6" md="6">
                                        <v-text-field
                                          v-model="editedItem.phone"
                                          label="Phone"
                                          type="text"
                                          v-mask="'(###) ###-####'"
                                          required
                                        ></v-text-field>
                                      </v-col>
                                      <v-col cols="12" sm="6" md="6">
                                        <v-text-field
                                          v-model="editedItem.company"
                                          label="Company"
                                          :rules="fieldRules"
                                          required
                                        ></v-text-field>
                                      </v-col>
                                      <v-col cols="12" sm="12" md="12">
                                        <v-text-field
                                          v-model="editedItem.address"
                                          label="Address"
                                          :rules="fieldRules"
                                          required
                                        ></v-text-field>
                                      </v-col>
                                      <v-col cols="12" sm="6" md="6">
                                        <v-text-field
                                          v-model="editedItem.title"
                                          label="Title"
                                          :rules="fieldRules"
                                          required
                                        ></v-text-field>
                                      </v-col>
                                      <v-col cols="12" sm="6" md="6">
                                        <v-autocomplete
                                          v-model="editedItem.language"
                                          label="Language"
                                          :rules="fieldRules"
                                          :items="languageOptions"
                                          required
                                        ></v-autocomplete>
                                      </v-col>
                                      <v-col cols="12" sm="6" md="6">
                                        <v-autocomplete
                                          v-model="editedItem.timezone"
                                          label="Timezone"
                                          :rules="fieldRules"
                                          :items="timezoneOptions"
                                          required
                                        ></v-autocomplete>
                                      </v-col>
                                      <v-col cols="12" sm="12" md="12">
                                        <v-radio-group
                                          v-model="editedItem.gender"
                                          label="Gender"
                                          row
                                          class="d-flex justify-content-sm-between"
                                          :rules="fieldRules"
                                          required
                                        >
                                          <v-radio
                                            label="Male"
                                            value="male"
                                            color="#5f6f85"
                                          ></v-radio>
                                          <v-radio
                                            label="Female"
                                            value="female"
                                            color="#5f6f85"
                                          ></v-radio>
                                          <v-radio
                                            label="Unspecified"
                                            value="unspecified"
                                            color="#5f6f85"
                                          ></v-radio>
                                        </v-radio-group>
                                      </v-col>
                                    </v-row>
                                  </v-container>
                                </v-card-text>
                                <v-card-actions>
                                  <div class="flex-grow-1"></div>
                                  <v-btn class="cancel" text @click="close"
                                    >Cancel</v-btn
                                  >
                                  <v-btn class="save" text @click="save"
                                    >Save</v-btn
                                  >
                                </v-card-actions>
                              </v-card>
                            </v-dialog>
                          </v-col>
                          <v-col cols="12" sm="3" md="6" lg="6">
                            <div class="action_item">
                              <font-awesome-icon
                                class="action-icon"
                                icon="trash-alt"
                              /><span class="delete">delete account</span>
                            </div>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </td>
                </template>
                <template v-slot:item.image class="image">
                  <img
                    src="/assets/images/myprofile.png"
                    alt=""
                    width="49px"
                    height="49px"
                  />
                </template>
                <template v-slot:item.fullname="{ item }">
                  <div class="original">
                    <div class="fullname">
                      <span class="bold">Full name</span
                      ><span>{{ item.fullname }}</span>
                    </div>
                    <div class="fullname empty">
                      <span class="bold">Full name</span
                      ><span>{{ item.fullname }}</span>
                    </div>
                  </div>
                  <div class="additional">
                    <div class="fullname">
                      <span class="bold">Last login</span
                      ><span>{{ item.lastlogin }}</span>
                    </div>
                    <div class="fullname">
                      <span class="bold"># of uploaded config files</span
                      ><span>{{ item.configfiles }}</span>
                    </div>
                  </div>
                </template>
                <template v-slot:item.emailphone="{ item }">
                  <div class="original">
                    <div class="fullname">
                      <span class="bold">Email</span
                      ><span>{{ item.email }}</span>
                    </div>
                    <div class="fullname">
                      <span class="bold">Phone</span
                      ><span>{{ item.phone }}</span>
                    </div>
                  </div>
                  <div class="additional">
                    <div class="fullname">
                      <span class="bold"># of vulnerabilities hunted</span
                      ><span>{{ item.hunted }}</span>
                    </div>
                    <div class="fullname">
                      <span class="bold"
                        ># of critical vulnerabilities hunted</span
                      ><span>{{ item.critical_hunted }}</span>
                    </div>
                  </div>
                  <div class="collapse_icon">
                    <font-awesome-icon
                      class="report"
                      icon="ellipsis-h"
                      @click="expandOnMobile"
                    />
                  </div>
                </template>
                <template v-slot:item.loginconfig="{ item }">
                  <div class="fullname">
                    <span class="bold">Last login</span
                    ><span>{{ item.lastlogin }}</span>
                  </div>
                  <div class="fullname">
                    <span class="bold"># of uploaded config files</span
                    ><span>{{ item.configfiles }}</span>
                  </div>
                </template>
                <template v-slot:item.hunted="{ item }">
                  <div class="fullname">
                    <span class="bold"># of vulnerabilities hunted</span
                    ><span>{{ item.hunted }}</span>
                  </div>
                  <div class="fullname">
                    <span class="bold"
                      ># of critical vulnerabilities hunted</span
                    ><span>{{ item.critical_hunted }}</span>
                  </div>
                </template>
                <template v-slot:item.report>
                  <font-awesome-icon
                    class="report"
                    icon="ellipsis-h"
                    show-expand
                    @click="expandOnDesktop"
                  />
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </div>
      </v-card-text>
      <v-card-actions class="footer">
        <v-btn class="commit" color="#2bb9aa" @click="updateProfile"
          >COMMIT</v-btn
        >
        <v-btn class="discard" color="white" @click="ShowEditPage"
          >DISCARD</v-btn
        >
      </v-card-actions>
      <!-- <v-card-actions class="footer" v-if="this.showProfile == true && this.showeditprofilepage == false">
                <v-btn class="commit" color="#2bb9aa" @click="ShowEditPage">EDIT</v-btn>
            </v-card-actions> -->
    </v-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      groupname: "",
      headers: [
        { text: "IMAGE", align: "center", sortable: false, value: "image" },
        {
          text: "Full Name",
          align: "left",
          sortable: false,
          value: "fullname"
        },
        {
          text: "Eamil & Phone",
          align: "left",
          sortable: false,
          value: "emailphone"
        },
        {
          text: "Login & Config",
          align: "left",
          sortable: false,
          value: "loginconfig"
        },
        { text: "Hunted", align: "left", sortable: false, value: "hunted" },
        { text: "REPORT", align: "left", sortable: false, value: "report" },
        { text: "Team", align: "left", sortable: false, value: "team" },
        { text: "Company", align: "left", sortable: false, value: "company" }
      ],
      allusers: [
        {
          id: 1,
          fullname: "Jack Smith",
          team: "sample team1",
          email: "joe@safe.com",
          phone: "123 456 789",
          lastlogin: "07/17/2019 15:43",
          configfiles: "32",
          hunted: "428",
          critical_hunted: "23",
          company: "Company 1",
          title: "Marketing Director",
          address: "Ap #867-860 Sit Rd., Azusa New York 39531, United States",
          language: "English",
          timezone: "GMT -4",
          gender: "Male"
        },
        {
          id: 2,
          fullname: "John Doe",
          team: "sample team2",
          email: "joe@safe.com",
          phone: "123 456 789",
          lastlogin: "07/17/2019 15:43",
          configfiles: "32",
          hunted: "428",
          critical_hunted: "23",
          company: "Toyato",
          title: "Marketing Director",
          address: "Ap #867-860 Sit Rd., Azusa New York 39531, United States",
          language: "English",
          timezone: "GMT -4",
          gender: "Male"
        }
      ]
    };
  },
  watch: {},
  mounted() {},
  computed: {},
  methods: {}
};
</script>
